import React from "react";
import ExcoProvinsi from "../../components/organism/ExcoProvinsi";

const PageExcoProvinsi = () => {
  return (
    <>
      <ExcoProvinsi />
    </>
  );
};

export default PageExcoProvinsi;
